module.exports = __webpack_public_path__ + "img/Website_Banner_girl_final.6031c7be.jpg";